'use client';

import { c as _c } from "react/compiler-runtime";
import { unwrapFromResult } from '@shared/utils/helpers/resultWrapper';
import toast from '@shared/utils/helpers/toast';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { PLATFORM_BRAND } from '../../utils/platformBrand';
import { client } from '../../utils/trpc';
import AppCard from './AppCard';
import { useOAuthReturn } from './useOAuthReturn';
type Props = {
  autoEnabled: boolean;
  issue?: boolean;
  onToggleAuto: () => void;
};
const LinkedinCard = t0 => {
  const $ = _c(13);
  const {
    autoEnabled,
    issue,
    onToggleAuto
  } = t0;
  const queryClient = useQueryClient();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      queryKey: ["linkedinHasToken"],
      queryFn: _temp,
      retry: false
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    data: status,
    isLoading
  } = useQuery(t1);
  let t2;
  if ($[1] !== queryClient) {
    t2 = async (code, state) => {
      const [error, data] = await client.platforms.linkedin.connect.mutate({
        code,
        state
      });
      if (error) {
        toast(error.message || "Failed to connect LinkedIn");
        return;
      }
      toast(`LinkedIn connected as ${data?.displayName ?? "your account"}`);
      await queryClient.invalidateQueries({
        queryKey: ["linkedinHasToken"]
      });
    };
    $[1] = queryClient;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  useOAuthReturn("linkedin", "LinkedIn", t2);
  const connect = _temp2;
  let t3;
  if ($[3] !== queryClient) {
    t3 = async () => {
      const [error_1] = await client.platforms.linkedin.disconnect.mutate();
      if (error_1) {
        toast(error_1.message || "Failed to disconnect LinkedIn");
        return;
      }
      toast("LinkedIn account disconnected.");
      await queryClient.invalidateQueries({
        queryKey: ["linkedinHasToken"]
      });
    };
    $[3] = queryClient;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const disconnect = t3;
  const t4 = !!status?.hasToken;
  const t5 = status?.displayName ? `Connected as ${status.displayName}` : undefined;
  let t6;
  if ($[5] !== autoEnabled || $[6] !== disconnect || $[7] !== isLoading || $[8] !== issue || $[9] !== onToggleAuto || $[10] !== t4 || $[11] !== t5) {
    t6 = <AppCard label="LinkedIn" brand={PLATFORM_BRAND.LINKEDIN} loading={isLoading} connected={t4} accountText={t5} supports="Cross-posts text, photos and videos" autoEnabled={autoEnabled} issue={issue} onConnect={connect} onDisconnect={disconnect} onToggleAuto={onToggleAuto} />;
    $[5] = autoEnabled;
    $[6] = disconnect;
    $[7] = isLoading;
    $[8] = issue;
    $[9] = onToggleAuto;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};
export default LinkedinCard;
function _temp() {
  return unwrapFromResult(client.platforms.linkedin.hasToken.query());
}
async function _temp2() {
  const [error_0, data_0] = await client.platforms.linkedin.getAuthUrl.query();
  if (error_0 || !data_0?.url) {
    toast("Failed to start LinkedIn connection");
    return;
  }
  window.location.href = data_0.url;
}